import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Dropdown from 'react-bootstrap/Dropdown';
import './NavBar.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/AuthProvider';

function NavBar({ handleSidebarToggle, breadcrum }) {
  const navigate = useNavigate();
  const auth = useAuth();

  const handleChangePassword=(e)=>{
    e.preventDefault();
    navigate('/change-password');
  }

  const handleSignOut=(e)=>{
    e.preventDefault();
    //logic to remove session or cookie to be added
    //navigate('/login');
    auth.logOut();
  }

  return (
    <React.Fragment>
      <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky" id="navbarBlur" navbar-scroll="true">
        <div className="container-fluid py-1 px-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
              <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="#">Pages</a></li>
              <li className="breadcrumb-item capitalize-first-letter text-sm text-dark active" aria-current="page">{breadcrum.navigation}</li>
            </ol>
            <h5 className="font-weight-bolder capitalize-first-letter mb-0">{breadcrum.title}</h5>
          </nav>
          <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
            <div className="ms-md-auto pe-md-3 d-flex align-items-center">

            </div>
            <ul className="navbar-nav  justify-content-end">
              <li className="nav-item d-flex d-none d-xl-block align-items-center">
                {/* <a href="/login" className="nav-link text-body font-weight-bold px-0">
                  <FontAwesomeIcon className='me-sm-1' icon={faUser} />
                  <span className="d-sm-inline d-none">Sign Out</span>
                </a> */}
                <Dropdown>
                  <Dropdown.Toggle variant="" id="dropdown-basic">
                  <FontAwesomeIcon className='me-sm-1' icon={faUser} />{auth.user}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={handleChangePassword}>Change password</Dropdown.Item>
                    <Dropdown.Item onClick={handleSignOut}>Sign out</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>                
              </li>
              <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
                <a href="#" className="nav-link text-body p-0" id="iconNavbarSidenav" onClick={handleSidebarToggle}>
                  <div className="sidenav-toggler-inner">
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                    <i className="sidenav-toggler-line"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
}

export default NavBar